export const USER_PER_PAGE = 6;

/* LOCAL STORAGE item*/

export const TOKEN = 'depositoryToken';
export const BEARER = 'Bearer ';
export const DEPOSITORY_USER = 'DEPOSITORY_USER';
export const DEPOSITORY_ROLE = 'DEPOSITORY_ROLE';
export const DEPOSITORY_CURRENT_MEETING = 'DEPOSITORY_CURRENT_MEETING';
export const DEPOSITORY_CURRENT_COMPANY = 'DEPOSITORY_CURRENT_COMPANY';
export const DEPOSITORY_MEMBER_TYPE_USER = 'DEPOSITORY_MEMBER_TYPE_USER';
export const DEPOSITORY_CURRENT_MEMBER = 'DEPOSITORY_CURRENT_MEMBER';
export const DEPOSITORY_ZOOM_MEETING_PASSWORD = 'DEPOSITORY_ZOOM_MEETING_PASSWORD';
export const DEPOSITORY_ZOOM_MEETING_LINK = 'DEPOSITORY_ZOOM_MEETING_LINK';


export const ADMIN = 'ADMIN';
export const ENTITY = 'ENTITY'; // Yuridik shaxs
export const FOREIGNER = 'FOREIGNER'; // Chet ellik
export const INDIVIDUAL = 'INDIVIDUAL'; // Jismoniy shaxs

/* FOR AGENDA */
export const TWOMIN = "TWOMIN";
export const FIVEMIN = "FIVEMIN";
export const TENMIN = "TENMIN";
export const FIFTEENMIN = "FIFTEENMIN";
export const TWENTYMIN = "TWENTYMIN";

/* FOR BALLOT */
export const FOR = 'FOR';
export const REFRAIN = 'REFRAIN';
export const AGAINST = 'AGAINST';

export const ROLE_ADMIN = 'ROLE_ADMIN';
export const CHAIR_MAN = 'CHAIR_MAN';

export const CHAIRMAN = 'CHAIRMAN';
export const SECRETARY = 'SECRETARY';
export const SPEAKER = 'SPEAKER';
export const WATCHER = 'WATCHER';
export const SIMPLE = 'SIMPLE';

// ANY, DISABLED, ERI, INPASS
export const ANY = 'ANY';
export const DISABLED = 'DISABLED';
export const ERI = 'ERI';
export const INPASS = 'INPASS';


export const ACTIVE = 'ACTIVE';
export const CANCELED = 'CANCELED';
export const FINISH = 'FINISH';
export const PENDING = 'PENDING';


export const EXTRAORDINARY = 'EXTRAORDINARY';
export const ORDINARY = 'ORDINARY';


